export default "__VITE_ASSET__DHB5NfWd__"